/**
 * Store branding shown in the web app (title, login, sidebar, download links). Comes from
 * restaurant-app/brand/<BRAND>.json at build time (vite.config.ts). The logo is black line art on
 * transparent (inverted to white in dark mode); null = show the name only.
 */
declare const __BRAND__: {
  name: string;
  logo: string | null;
  downloads: { windows: string; mac: string; android: string };
};

export const BRAND_NAME = __BRAND__.name;
export const BRAND_LOGO = __BRAND__.logo;
export const BRAND_DOWNLOADS = __BRAND__.downloads;
